import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DefaultLayout from 'layout/Default';
import { ProtectedRoute } from 'routes/RouteGuards';

const SearchBookingReportPage = Loadable(
  lazy(() => import('views/reports/SearchBookingReport'))
);

const DailyReportPage = Loadable(
  lazy(() => import('views/reports/DailyReport'))
);

const BookingReportPage = Loadable(
  lazy(() => import('views/reports/BookingReport'))
);

const RevenueReportPage = Loadable(
  lazy(() => import('views/reports/RevenueReport'))
);

const TransactionReportPage = Loadable(
  lazy(() => import('views/reports/TransactionReport'))
);

const FailedBookingReportPage = Loadable(
  lazy(() => import('views/reports/FailedBookingReport'))
);


const ReportsRoutes = {
  path: '/',
  element: <ProtectedRoute />,
  children: [
    {
      element: <DefaultLayout />,
      children: [
	    {
          path: 'reports/search-booking-report',
          element: <SearchBookingReportPage />
        },
		{
          path: 'reports/daily-report',
          element: <DailyReportPage />
        },
		{
          path: 'reports/booking-report',
          element: <BookingReportPage />
        },
		{
          path: 'reports/revenue',
          element: <RevenueReportPage />
        },
		{
          path: 'reports/transaction',
          element: <TransactionReportPage />
        },
        {
          path: 'reports/failed-bookings',
          element: <FailedBookingReportPage />
        }	
      ]
    }
  ]
};

export default ReportsRoutes;
